define('app/sdc/element/sdc-element',["$parse"], function ($parse) {
	// Exactly like ngTransclude, except it allows a custom expression to be executed on transclution to do things such as extending the scope.
	return {
		restrict: 'EA',
		scope: false,
		template: null,
		link: function ($scope, $element, $attrs) {
			$parse($attrs.sdcElement || $attrs.exec)($scope, {
				$target: {
					element: $element
				}
			});
		}
	}
});
